/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrUpdateTaskItemAreaDataDto
 */
export interface CreateOrUpdateTaskItemAreaDataDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrUpdateTaskItemAreaDataDto
     */
    $type?: CreateOrUpdateTaskItemAreaDataDtoTypeEnum;
}


/**
 * @export
 */
export const CreateOrUpdateTaskItemAreaDataDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoCreateOrUpdateTaskItemAreaDataDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.CreateOrUpdateTaskItemAreaDataDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateOrUpdateTaskItemAreaDataDtoTypeEnum = typeof CreateOrUpdateTaskItemAreaDataDtoTypeEnum[keyof typeof CreateOrUpdateTaskItemAreaDataDtoTypeEnum];



/**
 * Check if a given object implements the CreateOrUpdateTaskItemAreaDataDto interface.
 */
export function instanceOfCreateOrUpdateTaskItemAreaDataDto(value?: unknown): value is CreateOrUpdateTaskItemAreaDataDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateOrUpdateTaskItemAreaDataDtoTypeEnum)[0];
}

export function CreateOrUpdateTaskItemAreaDataDtoFromJSON(json: any): CreateOrUpdateTaskItemAreaDataDto {
    return CreateOrUpdateTaskItemAreaDataDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateTaskItemAreaDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateTaskItemAreaDataDto {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateOrUpdateTaskItemAreaDataDtoToJSON(value?: CreateOrUpdateTaskItemAreaDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        '$type': value['$type'],
    });
}

